import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Paper, IconButton } from '@mui/material';
import { FiArrowLeft } from 'react-icons/fi';
import { colors } from '../theme/modernTheme';
import { showSuccess } from '../utils/toast';
import TrustMasterForm from '../components/TrustMasterForm';
import { ArrowBack } from '@mui/icons-material';

/**
 * Trust Master New Page
 * Allows creating a new trust master
 */
export default function TrustMasterNewPage() {
  const navigate = useNavigate();

  const handleSave = () => {
    showSuccess('Trust master created successfully');
    navigate('/trust-masters');
  };

  const handleCancel = () => {
    navigate('/trust-masters');
  };

  return (
    <Box>
      {/* Page Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 3,
        }}
      >
        <IconButton
          onClick={() => navigate('/trust-masters')}
          size="small"
          sx={{
            '&:hover': { color: colors.primary.main },
          }}
        >
          <ArrowBack fontSize="small" />
        </IconButton>
        <Typography
          variant="h4"
          sx={{
            fontSize: '1.2rem',
            fontWeight: 700,
            color: colors.text.primary,
          }}
        >
          Create Trust
        </Typography>
      </Box>

      {/* Form */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: '4px',
          border: `1px solid ${colors.border.main}`,
          backgroundColor: colors.background.paper,
        }}
      >
        <TrustMasterForm trustMaster={null} onSave={handleSave} onCancel={handleCancel} />
      </Paper>
    </Box>
  );
}
